import { useState, useEffect } from 'react';
import Modal from '@Common/Modal';
import { useUtilityContext } from '@Context/prompt-toolbox/UtilityContext';
import DeletePrompt from '../modals/DeletePrompt';
import DeleteVersion from '../modals/DeleteVersion';
import ExpandedView from '../modals/ExpandedView';

const PromptModals = () => {
  const { modals, setModal } = useUtilityContext();
  const [contentToExpand, setContentToExpand] = useState<string>('');

  //special code snippet to sort for modals that concern expanding, it will get that  modal and use it below
  useEffect(() => {
    const expandKey = Object.keys(modals).find(
      (key) => modals[key] && key.startsWith('expand')
    );
    setContentToExpand(expandKey || '');
  }, [modals]);

  return (
    <>
      <Modal
        isOpen={modals.deletePrompt}
        onClose={() => setModal('deletePrompt', false)}
        title="Delete Prompt"
      >
        <DeletePrompt />
      </Modal>
      <Modal 
        isOpen={modals.deleteVersion}
        onClose={() => setModal('deleteVersion', false)}
        title="Delete Version"
      >
        <DeleteVersion />
      </Modal>

      {/* where sorted key from the modal will be inserted, so that no repetition of code for opening modal of each expanded view needed*/}
      {contentToExpand && modals[contentToExpand] && (
        <Modal
          isOpen={modals[contentToExpand]}
          onClose={() => setModal(contentToExpand, false)}
          title="Expanded View"
        >
          <ExpandedView modalSelected={contentToExpand} />
        </Modal>
      )}
    </>
  );
};

export default PromptModals;
